import { css } from '@mui/material'
import styledReset from 'emotion-reset'

import {
  ABCGintoNordMediumOtf,
  ABCGintoNordMediumWoff,
  ABCGintoNordMediumWoff2,
  ABCGintoNordRegularOtf,
  ABCGintoNordRegularWoff,
  ABCGintoNordRegularWoff2,
  MoretBoldOtf,
  MoretRegularOtf,
} from '../assets'
import { COLORS } from '../constants'
import { unit } from '../utils'

export const globalCss = css`
  ${styledReset};

  @font-face {
    font-family: 'ABC Ginto Nord';
    font-style: normal;
    font-weight: normal;
    font-display: swap;
    src:
      url(${ABCGintoNordRegularWoff2}) format('woff2'),
      url(${ABCGintoNordRegularWoff}) format('woff'),
      url(${ABCGintoNordRegularOtf}) format('opentype');
  }

  @font-face {
    font-family: 'ABC Ginto Nord';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src:
      url(${ABCGintoNordRegularWoff2}) format('woff2'),
      url(${ABCGintoNordRegularWoff}) format('woff'),
      url(${ABCGintoNordRegularOtf}) format('opentype');
  }

  @font-face {
    font-family: 'ABC Ginto Nord';
    font-style: normal;
    font-weight: bold;
    font-display: swap;
    src:
      url(${ABCGintoNordMediumWoff2}) format('woff2'),
      url(${ABCGintoNordMediumWoff}) format('woff'),
      url(${ABCGintoNordMediumOtf}) format('opentype');
  }

  @font-face {
    font-family: 'Moret';
    font-style: normal;
    font-weight: normal;
    font-display: block;
    src: url(${MoretRegularOtf}) format('opentype');
  }

  @font-face {
    font-family: 'Moret';
    font-style: normal;
    font-weight: bold;
    font-display: block;
    src: url(${MoretBoldOtf}) format('opentype');
  }

  html {
    overflow-y: scroll;
  }

  html,
  body,
  #root {
    height: 100%;
    width: 100%;
    font-family: 'ABC Ginto Nord', sans-serif;
    background-color: ${COLORS.vaalea['60%']};
  }

  * {
    box-sizing: border-box;
  }

  a,
  button,
  input,
  select,
  textarea,
  div[tabindex],
  span[tabindex] {
    &:focus-visible {
      outline: ${unit(1)} solid ${COLORS.semantic.info};
      outline-offset: ${unit(0.5)};
    }
  }
`
